export default __webpack_public_path__ + "static/media/companyBox.70b4f7eb.png";